import Section from './section'
import Layouts from './layouts'
import ErrorPage from './errorPage'
import Card from './card'
import ChildrenCard from './childrenCard'
import Status from './status'
import NonsupportI18n from './nonsupportI18n'
// import Ele from '@/components/element.js'
import Jcele from '@/components/jcElement.js'
import Upload from './upload'

const components = [
  NonsupportI18n,
  Section,
  Layouts,
  ErrorPage,
  Card,
  ChildrenCard,
  Status,
  Upload,
]
const install = (Vue) => {
  if (install.installed) {
    return
  }
  // Vue.use(Ele)
  Vue.use(Jcele)

  components.forEach((component) => {
    Vue.component(component.name, component)
  })
}

export default {
  install,
}
